module.exports = __webpack_public_path__ + "img/mawyc.b94046e5.jpg";